<template>
  <div>
    <transition name="slide-up">
      <div class="parent" v-bind:key="answer">
        <div class="maincards" v-if="!clicked">
          <transition name="flip">
            <v-card rounded color="#e74c3c" class="mainCard" v-if="nextClicked" @click="nextClicked = false"
              v-bind:key="nextClicked">
              <div class="innerData">
                <p class="ma-0 pa-0 large_text wtText"> For {{ user }} </p>
              </div>
            </v-card>
            <v-card rounded color="#ffb6c1" class="mainCard" v-else>
              <div class="innerData">
                <p class="ma-0 pa-0 large_text wtText" id="question"> Will you be my valentine? </p>
                <div class="controls">
                  <v-btn dark style="text-transform: unset;" @click="yesClicked" color="#e74c3c">Yes</v-btn> <v-btn
                    style="text-transform: unset;" @click="answer = false; noClicked = true"
                    v-if="!noClicked">No</v-btn>
                </div>
              </div>
            </v-card>
          </transition>
        </div>
        <div class="showResults" v-else>
          <v-card class="vyes" v-if="answer" color="#ffb6c1">
            <div class="yesinner">

              <div class="rotate">
                <img src="../assets/heart.gif" style="height: 100%;
    width: 100%;">
              </div>
              <p class="large_text bTEXT"><strong>Yay!</strong></p>
            </div>
          </v-card>
        </div>
      </div>
    </transition>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      This is not server integrated, so please take screenshot and send back please !

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>


export default {
  name: 'MainComponent',

  components: {

  },
  methods: {
    yesClicked() {
      let _this = this;
      this.clicked = true; this.answer = true;
      setTimeout(() => {
        _this.snackbar = true
      }, 1500);
    }
  },
  props: {
    user: String
  },
  data: () => ({
    nextClicked: true,
    clicked: false,
    answer: false,
    noClicked: false,
    snackbar: false,
    timeout: 4000
  }),
};
</script>
<style scoped>
.flip-enter-active {
  transition: all 0.4s ease;
}

.bTEXT {
  color: #e74c3c;
  font-style: italic;
}

.vyes {
  width: 100%;
  height: 100%;
  border-radius: 12px !important;
}

.rotate {
  transform: rotate(-3deg);
  height: 70%;
  width: 70%;
  display: flex;
  object-fit: contain;
  border-radius: 16px;
  border: 2px solid brown;
  padding: 2px;
  box-sizing: border-box;
  overflow: hidden;
  background: #fafaf8;
}

.yesinner {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.35s ease-out;
}

#question:hover {
  transform: scale(1.5);
}

#question {
  transition-duration: 2s;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.flip-leave-active {
  display: none;
}

.flip-enter,
.flip-leave {
  transform: rotateY(180deg);
  opacity: 0;
}

.wtText {
  color: white;
}

.mainCard {
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 12px !important;
}

.maincards {
  display: inline-block;
  position: relative;
  height: 60%;
  width: 60%;
}

.showResults {
  height: 60%;
  width: 60%;
}

.large_text {
  font-size: x-large;
}

.controls {
  display: flex;
  gap: 10px;
  width: 100%;
  padding: 5px;
  position: absolute;
  bottom: 0;
  align-items: center;
  justify-content: center;
}

.innerData {
  display: flex;
  height: 100%;
  width: 100%;
  font-family: cursive;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}


.parent {
  height: 100dvh;
  width: 100dvw;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>